import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogConfig, MatDialogRef } from '@angular/material';
import { AssistanceCoverageVariantPricing } from '../../additional-options-section/assistance-coverages-comparison/assistance-coverages-comparison.config';
import {AssistanceCoverage} from '../../../../../core/consts/offer-modification-code.enum';
import { isNotNullOrUndefined } from 'codelyzer/util/isNotNullOrUndefined';
import {
  AcVariantsCoveragesComparisonConfig,
  AcVariantsCoveragesCoverageConfigModel
} from '../ac-variants-coverages-comparison.config';
import { DialogConfigBase } from '../../../../components/dialogs/dialog-config-base';
import { DialogConfigInterface } from '../../../../components/dialogs/dialog-config.interface';
import {
  AcVariantCoverage,
  AcVariantCoveragePricing,
  BeesafeAcCoverageVariant
} from '../ac-variants.coverage';
import { SelectedOfferService } from '../../../../../core/services/impl/section-services/selected-offer/selected-offer.service';
import {StickyCloseDialogComponent} from '../../../../components/dialogs/sticky-close-dialog/sticky-close-dialog.component';
import {DeviceService} from '../../../../services/device.service';
import {
  OfferModificationsConfigService
} from '../../../../../core/services/impl/offer-modifications/offer-modifications-config.service';
import {
  OfferModificationsService
} from '../../../../../core/services/impl/offer-modifications/offer-modifications.service';
import {InsuranceCompanyCode} from '../../../../models/insurance-company-code.enum';

@Component({
  selector: 'app-ac-variants-comparisons-dialog',
  templateUrl: './ac-variants-comparisons-dialog.component.html',
  styleUrls: ['./ac-variants-comparisons-dialog.component.scss']
})
export class AcVariantsComparisonsDialogComponent extends StickyCloseDialogComponent implements OnInit {

  coveragesConfig: AcVariantsCoveragesCoverageConfigModel[];
  pricingData: AssistanceCoverageVariantPricing[];
  pricesVisible: boolean;
  variantsOrder: AcVariantCoverage[];
  wideComparison: boolean;

  static getConfigBuilder(): AcVariantsComparisonsDialogComponentConfig {
    return new AcVariantsComparisonsDialogComponentConfig();
  }

  constructor(@Inject(MAT_DIALOG_DATA) public data: AcVariantCoveragePricing[],
              public deviceService: DeviceService,
              private dialog: MatDialogRef<AcVariantsComparisonsDialogComponent>,
              private selectedOfferService: SelectedOfferService,
              private offerModificationsService: OfferModificationsService,
              private configService: OfferModificationsConfigService) {
    super(deviceService);
  }

  ngOnInit() {
    super.ngOnInit();
    this.wideComparison = [InsuranceCompanyCode.UNIQA, InsuranceCompanyCode.PEVNO].includes(this.configService.insuranceCompanyCode);
    this.createConfig();
    this.sortPricingData();
  }

  close() {
    this.dialog.close();
  }

  selectAssistance(name: AssistanceCoverage): void {
    this.dialog.close(name);
  }

  createConfig(): void {
    const config = new AcVariantsCoveragesComparisonConfig(this.configService.insuranceCompanyCode, this.offerModificationsService, this.selectedOfferService);
    this.coveragesConfig = config.getFullComparisonConfig();
    this.variantsOrder = config.getVariantsOrder();
  }

  getCoverageLabel(name: string): string {
    return `AC_VARIANTS_COMPARISON.coveragesLabels.${name}`;
  }

  hasVariant(variantName: string): boolean {
    return !!this.data.find((pricingItem: AcVariantCoveragePricing) => pricingItem.name === variantName);
  }

  getVariantValue(variant: BeesafeAcCoverageVariant, config: AcVariantsCoveragesCoverageConfigModel): string | boolean {
    const variantItem = config.values.find(item => item.coverage === variant);
    return variantItem ? variantItem.value : null;
  }

  private sortPricingData(): void {
    this.pricesVisible = !this.configService.isUniqaOrPevno;
      const data = [];
      this.variantsOrder.forEach(name => {
        const variantExists = this.data && isNotNullOrUndefined(this.data.find(dataItem => dataItem.name === name));
        if (variantExists) {
          let item: AcVariantCoveragePricing = {
            name: name
          };
          if (isNotNullOrUndefined(this.data)) {
            const pricingData = this.data.find((pricingItem: AcVariantCoveragePricing) => pricingItem.name === name);
            item.price = pricingData.price;
          }
          data.push(item);
        }
      });
      this.pricingData = data;
  }

}

export class AcVariantsComparisonsDialogComponentConfig extends DialogConfigBase implements DialogConfigInterface {
  private config: MatDialogConfig = {
    disableClose: true,
    panelClass: ['app-offers-dialog', 'offer-modifications-comparison-dialog-panel']
  };

  constructor() {
    super();
  }

  buildConfiguration(data?: AssistanceCoverageVariantPricing[]): MatDialogConfig {
    return this.buildConfig(data, this.config);
  }
}
